module.exports = require('./convert')(
  "exportsfuncEOPQRTW`abdghijklmqvwyz",
  "ㄷㅌㅔㅐㄱㅅㄴㄹㅕㅜㅊㄸㅒㅖㅃㄲㅆㅉ₩ㅁㅠㅇㅎㅗㅑㅓㅏㅣㅡㅂㅍㅈㅛㅋ"
)
